export const UPDATE_PLC_SAFETY_TRIGGER = 'UPDATE_PLC_SAFETY_TRIGGER';
export const UPDATE_PLC_SAFETY_TRIGGER_SUCCESSFUL = 'UPDATE_PLC_SAFETY_TRIGGER_SUCCESSFUL';
export const UPDATE_PLC_SAFETY_TRIGGER_FAILED = 'UPDATE_PLC_SAFETY_TRIGGER_FAILED';
